import axios from 'axios'
import { setCampaignFromVoucher } from '../utils/campaignContext'

const dominio = process.env.NODE_ENV === 'development' 
  ? '/' 
  : 'https://jupiter.grub.digital/'

// Função para obter brand baseado no ambiente
const getBrand = (brand) => {
  // Se estiver em localhost, sempre usar 'gente-bonita'
  if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.0.48') {
    return 'gente-bonita'
  }
  return brand
}




// Configuração global do axios
axios.defaults.timeout = 10000
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'

// Interceptor de resposta para tratamento de erros
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error)
  }
)

const handleGet = async (route, params = {}) => {
  try {
    const request = await axios.get(`${dominio}${route}`, { params })
    return request.data
  } catch (error) {
    return false
  }
}

const handlePost = async (route, data) => {
  try {
    const request = await axios.post(`${dominio}${route}`, data)
    return request.data
  } catch (error) {
    // Retornar erro com mensagem para tratamento específico
    if (error.response && error.response.data) {
      return {
        success: false,
        message: error.response.data.message || 'Erro no servidor'
      }
    }
    return {
      success: false,
      message: error.message || 'Erro de conexão'
    }
  }
}

const handlePut = async (route, data) => {
  try {
    const request = await axios.put(`${dominio}${route}`, data)
    return request.data
  } catch (error) {
    return false
  }
}

const handlePatch = async (route, data) => {
  try {
    const request = await axios.patch(`${dominio}${route}`, data)
    return request.data
  } catch (error) {
    return false
  }
}

const handleDelete = async (route, data) => {
  try {
    const request = await axios.delete(`${dominio}${route}`, { data })
    return request.data
  } catch (error) {
    return false
  }
}

// Buscar cardápio por brand e tipo de entrega
export const getCardapio = async (brand, isDelivery = false) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/cardapio/${finalBrand}`, { delivery: isDelivery })
}

// Registrar acesso ao cardápio (popula gb_acessos para telemetria)
export const registrarAcessoCardapio = async (brand, idEcLoja) => {
  const finalBrand = getBrand(brand)
  // Reutiliza sitri_token se existir, senão gera um token anônimo de sessão
  let token = localStorage.getItem('sitri_token')
  if (!token) {
    token = localStorage.getItem('sitri_anon_token')
    if (!token) {
      token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      localStorage.setItem('sitri_anon_token', token)
    }
  }
  // Fire-and-forget — não bloqueia nem lança erro para o caller
  handlePost(`public/acesso/${finalBrand}`, { token, id_ec_loja: idEcLoja }).catch(() => {})
}

// Buscar banners do cardápio
export const getBannersCardapio = async (brand) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/banners/${finalBrand}`)
}

// Buscar informações da loja
export const getLojaInfo = async (brand) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/loja/${finalBrand}`)
}

// Buscar detalhes de um produto
export const getProdutoDetalhes = async (brand, produtoId) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/produto/${finalBrand}/${produtoId}`)
}

// Buscar upsells de um produto
export const getProdutoUpsells = async (brand, produtoId) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/produto/${finalBrand}/${produtoId}/upsels`)
}

// Buscar mesa por token
export const getMesaByToken = async (brand, token) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/mesa/${finalBrand}/${token}`)
}

// Buscar comanda aberta por mesa
export const getComandaByMesa = async (brand, token) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/mesa/${finalBrand}/${token}/comanda`)
}



// Criar comanda
export const criarComanda = async (brand, dadosComanda) => {
  const finalBrand = getBrand(brand)
  
  // Verificar se há token salvo e incluir no header
  const token = localStorage.getItem('sitri_token')
  const originalHeaders = axios.defaults.headers.common['Authorization']
  
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  
  try {
    const result = await handlePost(`public/comanda/${finalBrand}`, dadosComanda)
    return result
  } finally {
    // Restaurar header original
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else if (token) {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Adicionar produto à comanda
export const adicionarProduto = async (brand, comandaId, produto) => {
  const finalBrand = getBrand(brand)
  
  // Verificar se há token salvo e incluir no header
  const token = localStorage.getItem('sitri_token')
  const originalHeaders = axios.defaults.headers.common['Authorization']
  
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  
  try {
    const result = await handlePost(`public/comanda/${finalBrand}/${comandaId}/produto`, produto)
    return result
  } finally {
    // Restaurar header original
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else if (token) {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Buscar comanda por ID
export const getComanda = async (brand, comandaId) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/comanda/${finalBrand}/${comandaId}`)
}

// Buscar comanda por hash (WhatsApp)
export const getComandaByHash = async (brand, hash) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/comanda/${finalBrand}/hash/${hash}`)
}

// Buscar pedido por hash (Sitri - detalhes)
export const getPedidoByHash = async (brand, hash) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/pedido/${finalBrand}/${hash}`)
}

// Atualizar comanda
export const updateComanda = async (brand, comandaId, dados) => {
  const finalBrand = getBrand(brand)
  return await handlePut(`public/comanda/${finalBrand}/${comandaId}`, dados)
}

// Remover produto da comanda
export const removeProduto = async (brand, comandaId, produtoId) => {
  const finalBrand = getBrand(brand)
  return await handleDelete(`public/comanda/${finalBrand}/${comandaId}/produto/${produtoId}`)
}

// ===== AUTENTICAÇÃO DE CLIENTES =====

// Login de cliente (global)
export const loginCliente = async (cpf, senha) => {
  return await handlePost('public/cliente/login', { cpf, senha })
}

// Cadastro de cliente (global)
export const registerCliente = async (dados) => {
  return await handlePost('public/cliente/register', dados)
}

// Login com Google (global)
export const loginGoogleCliente = async (googleCredential) => {
  return await handlePost('public/cliente/google-login', { 
    credential: googleCredential 
  })
}

// Completar cadastro com dados do Google
export const completeGoogleRegistration = async (dados) => {
  return await handlePost('public/cliente/complete-google-registration', dados)
}

// Vincular cliente à brand
export const vincularClienteBrand = async (token, brand) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePost('public/cliente/vincular-brand', { brand })
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Verificar token JWT
export const verifyToken = async (token) => {
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleGet('public/me')
    return result
  } catch (error) {
    return false
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Converter token WhatsApp em JWT
export const convertWhatsAppToken = async (whatsToken) => {
  return await handlePost('public/whatsapp/verify-token', { token: whatsToken })
}

// Buscar perfil do cliente (rota protegida)
export const getClienteProfile = async (token) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleGet('public/cliente/profile')
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Adicionar endereço
export const adicionarEndereco = async (token, endereco) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePost('public/cliente/endereco', endereco)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Remover endereço
export const removerEndereco = async (token, enderecoId) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleDelete(`public/cliente/endereco/${enderecoId}`)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Cartões são salvos automaticamente após pagamento via Asaas

// Remover cartão de crédito
export const removerCartao = async (token, cartaoId) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleDelete(`public/cliente/cartao/${cartaoId}`)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Listar cartões do cliente
export const getCartoes = async (token) => {
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleGet('public/cliente/cartoes')
    return result
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Erro ao carregar cartões'
    }
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}



// ===== VALIDAÇÃO DE ENTREGA =====

// Validar endereço para entrega
export const validarEnderecoEntrega = async (brand, endereco, cep = null, lat = null, lng = null) => {
  const finalBrand = getBrand(brand)
  
  // Construir payload apenas com campos que têm valor
  const payload = {}
  if (endereco) payload.endereco = endereco
  if (cep) payload.cep = cep
  if (lat !== null && lat !== undefined) payload.lat = lat
  if (lng !== null && lng !== undefined) payload.lng = lng
  
  return await handlePost(`public/entrega/validar/${finalBrand}`, payload)
}

// Buscar zonas de entrega
export const getZonasEntrega = async (brand) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/entrega/zonas/${finalBrand}`)
}

// Validar voucher/cupom
export const validarVoucher = async (brand, codigo, valorPedido) => {
  const finalBrand = getBrand(brand)
  const token = localStorage.getItem('sitri_token') || null
  const resultado = await handlePost(`public/voucher/validar/${finalBrand}`, { codigo, valorPedido, token })
  
  // Se a resposta incluir campanha_id, atualizar contexto de campanha
  if (resultado && resultado.success && resultado.campanha_id) {
    setCampaignFromVoucher(resultado.campanha_id)
  }
  
  return resultado
}

// Buscar vouchers de fidelidade disponíveis do usuário (resgatados mas não utilizados)
export const getVouchersFidelidade = async (brand) => {
  const finalBrand = getBrand(brand)
  const token = localStorage.getItem('sitri_token')
  if (!token) return { success: false, data: [] }
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleGet(`public/fidelidade/vouchers/${finalBrand}`)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Criar pagamento
export const criarPagamento = async (brand, dadosPagamento) => {
  const finalBrand = getBrand(brand)
  
  // Verificar se há token salvo e incluir no header
  const token = localStorage.getItem('sitri_token')
  const originalHeaders = axios.defaults.headers.common['Authorization']
  
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  
  try {
    const result = await handlePost(`public/pagamento/${finalBrand}`, dadosPagamento)
    return result
  } finally {
    // Restaurar header original
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else if (token) {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Criar pagamento com cartão (salvo ou novo)
export const criarPagamentoCartao = async (brand, dadosPagamento, cardSelection) => {
  const finalBrand = getBrand(brand)
  
  // Verificar se há token salvo e incluir no header
  const token = localStorage.getItem('sitri_token')
  const originalHeaders = axios.defaults.headers.common['Authorization']
  
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  
  try {
    let paymentData = {
      ...dadosPagamento,
      tipo_pagamento: 'CREDITO'
    }
    
    // Configurar dados do cartão baseado no tipo de seleção
    if (cardSelection.type === 'saved') {
      // Cartão salvo - usar ID do cartão
      paymentData.dados_cartao = {
        id: cardSelection.cardId,
        salvar_cartao: false // Já está salvo
      }
    } else {
      // Cartão novo - enviar dados completos
      paymentData.dados_cartao = {
        ...cardSelection.cardData,
        salvar_cartao: true // Salvar o novo cartão
      }
    }
    
    const result = await handlePost(`public/pagamento/cartao/${finalBrand}`, paymentData)
    return result
  } finally {
    // Restaurar header original
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else if (token) {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Consultar status da comanda
export const consultarStatusComanda = async (brand, comandaId) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/comanda/${finalBrand}/${comandaId}/status`)
}

// Vincular comanda ao cliente
export const vincularComandaCliente = async (brand, comandaId, clienteId) => {
  const finalBrand = getBrand(brand)
  return await handlePost(`public/comanda/${finalBrand}/${comandaId}/vincular-cliente`, { clienteId })
}

// Buscar comandas do cliente logado
export const getComandasCliente = async (brand, token) => {
  const finalBrand = getBrand(brand)
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const url = `public/cliente/comandas/${finalBrand}`
    const result = await handleGet(url)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Atualizar dados do usuário temporário
export const updateTempUser = async (token, userData) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePut('public/cliente/update-temp-user', userData)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Atualizar dados do perfil do cliente
export const updateClienteProfile = async (token, userData) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePut('public/cliente/profile', userData)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Autocomplete de endereços via Xerxes
export const getEnderecoSugestoes = async (endereco) => {
  try {
    const enderecoFormatado = endereco.replace(/\s+/g, '+')
    const result = await axios.get(`https://xerxes.grub.digital/endereco/autocomplete/${enderecoFormatado}?language=pt-BR`)
    return result.data
  } catch (error) {
    return { predictions: [] }
  }
}

// Buscar detalhes completos do endereço
export const getEnderecoCompleto = async (endereco) => {
  try {
    const enderecoFormatado = endereco.replace(/\s+/g, '+')
    const result = await axios.get(`https://xerxes.grub.digital/enderecocompleto/${enderecoFormatado}?language=pt-BR`)
    return result.data
  } catch (error) {
    return null
  }
}

// Concierge IA - Sugestões de produtos
export const getConciergesuggestions = async (brand, message) => {
  const finalBrand = getBrand(brand)
  try {
    const response = await axios.post(`https://belial.grub.digital/api/whatsapp/test/${finalBrand}`, {
      message: message,
      phone: '5511987654321'
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// Vincular pedido anônimo ao usuário
export const vincularPedidoAnonimo = async (token, pedidoData) => {
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePost('public/cliente/vincular-pedido-anonimo', pedidoData)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Processar callback OAuth do Google
export const processOAuthCallback = async (code, state) => {
  return await handlePost('public/oauth/google/callback', { code, state })
}

// Verificar status do pagamento PIX
export const verificarStatusPagamento = async (brand, comandaId) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/comanda/${finalBrand}/${comandaId}/status`)
}

// Criar reserva
export const criarReserva = async (brand, dados) => {
  const finalBrand = getBrand(brand)
  return await handlePost(`public/reserva/${finalBrand}`, dados)
}

// ===== FILA DE ATENDIMENTO =====

// Entrar na fila de atendimento
export const entrarNaFila = async (brand, dados) => {
  const finalBrand = getBrand(brand)
  return await handlePost(`public/fila/${finalBrand}`, dados)
}

// Consultar posição na fila por hash
export const consultarPosicaoFila = async (brand, hash) => {
  const finalBrand = getBrand(brand)
  return await handleGet(`public/fila/${finalBrand}/${hash}`)
}

// Abandonar fila
export const abandonarFila = async (brand, hash) => {
  const finalBrand = getBrand(brand)
  return await handlePatch(`public/fila/${finalBrand}/${hash}/desistir`, {})
}


// ===== FIDELIDADE - PRODUTOS GRÁTIS =====

// Buscar produtos grátis disponíveis (resgatados pelo programa de fidelidade)
export const getProdutosGratisFidelidade = async (brand) => {
  const finalBrand = getBrand(brand)
  const token = localStorage.getItem('sitri_token')
  if (!token) return { success: false, data: [] }
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handleGet(`public/fidelidade/produtos-gratis/${finalBrand}`)
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

// Usar produto grátis (adicionar como cortesia na comanda)
export const usarProdutoGratis = async (brand, resgateId, comandaId) => {
  const finalBrand = getBrand(brand)
  const token = localStorage.getItem('sitri_token')
  if (!token) return { success: false, message: 'Não autenticado' }
  
  const originalHeaders = axios.defaults.headers.common['Authorization']
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  
  try {
    const result = await handlePost(`public/fidelidade/usar-produto/${finalBrand}`, {
      resgate_id: resgateId,
      comanda_id: comandaId
    })
    return result
  } finally {
    if (originalHeaders) {
      axios.defaults.headers.common['Authorization'] = originalHeaders
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  }
}
